
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/episode/[...slug]",
      function () {
        return require("private-next-pages/episode/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/episode/[...slug]"])
      });
    }
  